
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { FiMoreVertical } from "react-icons/fi";
import "./quickpayments.css";

const QuickPayment = () => {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [amount, setAmount] = useState("");

  const [loadingGroups, setLoadingGroups] = useState(false);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [processingPayment, setProcessingPayment] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const [payLinks, setPayLinks] = useState([]);
  const [loadingPayLinks, setLoadingPayLinks] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  // Dropdown state (by link id)
  const [activeDropdown, setActiveDropdown] = useState(null); // first level
  const [statusSelectDropdown, setStatusSelectDropdown] = useState(null); // second level

  // modal
  const [modalData, setModalData] = useState(null); // { ...link, status }
  const [modalInput, setModalInput] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);

  // refs (map of linkId -> element)
  const firstDropdownRefs = useRef({});
  const statusDropdownRefs = useRef({});
  const actionBtnRefs = useRef({});
  const modalRef = useRef(null);
const [paymentMode, setPaymentMode] = useState("Cash");
const [notes, setNotes] = useState("");

  const upiID = "bodhimaramplayschool@okaxis";
  const payeeName = "Bodhimaram Play School";


  //mobile drop down
    const [showPaymentModeList, setShowPaymentModeList] = useState(false);
// const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
const [isMobile, setIsMobile] = useState(
  typeof window !== "undefined"
    ? window.innerWidth <= 768
    : false
);


const [showGroupList, setShowGroupList] = useState(false);
// const isMobile = window.innerWidth <= 768;

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
 

  
  // fetch groups
  useEffect(() => {
    setLoadingGroups(true);
    axios
      .get("https://bodhimaram.onrender.com/group/groups")
      .then((res) => setGroups(res.data || []))
      .catch((err) => console.error(err))
      .finally(() => setLoadingGroups(false));
  }, []);

  // fetch students for group
  useEffect(() => {
    if (!selectedGroup) return;
    setLoadingStudents(true);
    axios
      .get(`https://bodhimaram.onrender.com/api/students/${selectedGroup}`)
      .then((res) => setStudents(res.data || []))
      .catch((err) => console.error(err))
      .finally(() => setLoadingStudents(false));
  }, [selectedGroup]);

  // fetch paylinks
  const fetchPayLinks = () => {
    setLoadingPayLinks(true);
    axios
      .get("https://bodhimaram.onrender.com/paylinks")
      .then((res) => {
        const sorted = (res.data || []).sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setPayLinks(sorted);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoadingPayLinks(false));
  };
  useEffect(() => fetchPayLinks(), []);

  // outside click handler: closes only open elements if clicked outside them
  useEffect(() => {
    function handleClickOutside(e) {
      // First dropdown
      if (
        activeDropdown &&
        firstDropdownRefs.current[activeDropdown] &&
        !firstDropdownRefs.current[activeDropdown].contains(e.target) &&
        !(actionBtnRefs.current[activeDropdown] && actionBtnRefs.current[activeDropdown].contains(e.target))
      ) {
        setActiveDropdown(null);
      }

      // Second dropdown
      if (
        statusSelectDropdown &&
        statusDropdownRefs.current[statusSelectDropdown] &&
        !statusDropdownRefs.current[statusSelectDropdown].contains(e.target) &&
        !(actionBtnRefs.current[statusSelectDropdown] && actionBtnRefs.current[statusSelectDropdown].contains(e.target))
      ) {
        setStatusSelectDropdown(null);
      }

      // Modal
      if (modalData && modalRef.current && !modalRef.current.contains(e.target)) {
        setModalData(null);
        setConfirmModal(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeDropdown, statusSelectDropdown, modalData]);

  // open status modal (from second dropdown)
  const openStatusModal = (link, selectedStatus) => {
    setModalData({ ...link, status: selectedStatus });
    setModalInput("");
    setConfirmModal(false);
    setStatusSelectDropdown(null);
    setActiveDropdown(null);
  };

  // confirm status change
  const handleConfirmStatusChange = async () => {
    if (!modalData) return;
    try {
      const res = await fetch(
        `https://bodhimaram.onrender.com/paylinks/${modalData.id}/status`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ status: modalData.status, details: modalInput }),
        }
      );
      if (!res.ok) throw new Error("Failed to update status");
      fetchPayLinks();
      setModalData(null);
      setConfirmModal(false);
    } catch (err) {
      console.error(err);
      alert("⚠️ Failed to update status");
    }
  };



const handleManualPayment = async () => {
  if (!selectedGroup || !selectedStudent || !amount) {
    alert("Fill all fields");
    return;
  }

  try {
    
await axios.post("https://bodhimaram.onrender.com/manual", {
  student_id: selectedStudent.id,        // ✅ ADD THIS
  student_name: selectedStudent.childname,
  class_name: selectedGroup,
  amount,
  phone: selectedStudent.primary_no,
  payment_mode: paymentMode,
  description: notes,
});


    alert("✅ Manual payment added");

    setAmount("");
    setNotes("");
    setSelectedStudent(null);

    fetchPayLinks(); // refresh

  } catch (err) {
    console.error(err);
    alert("❌ Failed");
  }
};

  // send pay link
  const handleSendPayLink = async () => {
    if (!selectedGroup || !selectedStudent || !amount || amount <= 0) {
      alert("⚠️ Please select group, student, and enter a valid amount.");
      return;
    }

    const note = `Fee payment for ${selectedStudent.childname}`;
    const upiLink = `upi://pay?pa=${upiID}&pn=${encodeURIComponent(
      payeeName
    )}&am=${amount}&cu=INR&tn=${encodeURIComponent(note)}`;

    const message = `Hi ${selectedStudent.parentname}, 👋\n\nYour fee amount of ₹${amount} for ${selectedStudent.childname} is due.\nPlease complete your payment securely using the UPI link below 👇\n\n${upiLink}\n\nAfter payment, kindly share your Screenshot for verification.\n\n— Bodhimaram Play School`;

    const waLink = `https://wa.me/${selectedStudent.primary_no}?text=${encodeURIComponent(
      message
    )}`;

    try {
      setProcessingPayment(true);
     

await axios.post("https://bodhimaram.onrender.com/save-paymentlink", {
  student: selectedStudent,
  group: selectedGroup,
  amount,
  upiLink,
  student_id: selectedStudent.id   // optional (backend already uses student.id)
});


      setShowSuccess(true);
      setShowError(false);
      setTimeout(() => setShowSuccess(false), 5000);
      window.open(waLink, "_blank");
      setAmount("");
      setSelectedStudent(null);
      fetchPayLinks();
    } catch (err) {
      console.error(err);
      setShowError(true);
      setShowSuccess(false);
      setTimeout(() => setShowError(false), 5000);
    } finally {
      setProcessingPayment(false);
    }
  };

  // change status quick toggle (optional)
  const handleChangeStatus = (id, currentStatus) => {
    const nextStatus =
      currentStatus === "Pending"
        ? "Paid"
        : currentStatus === "Paid"
        ? "Failed"
        : "Pending";
    setUpdatingId(id);
    axios
      .put(`https://bodhimaram.onrender.com/paylinks/${id}/status`, { status: nextStatus })
      .then(() => fetchPayLinks())
      .catch((err) => console.error(err))
      .finally(() => setUpdatingId(null));
  };

  const handleSendReminder = (link, type) => {
    const message = `Hi ${link.student_name}, 👋\n\nYour fee amount of ₹${link.amount} for ${link.student_name} is due.\nPlease complete your payment securely using the UPI link below 👇\n\n${link.upi_link}\n\nAfter payment, kindly share your UTR number for verification.\n\n— Bodhimaram Play School`;
    if (type === "whatsapp") {
      const waLink = `https://wa.me/${link.phone}?text=${encodeURIComponent(message)}`;
      window.open(waLink, "_blank");
    } else {
      const smsLink = `sms:${link.phone}?body=${encodeURIComponent(message)}`;
      window.open(smsLink, "_blank");
    }
    // close dropdown after action
    setActiveDropdown(null);
    setStatusSelectDropdown(null);
  };

  const statusColors = {
    Pending: "#FFA500",
    Paid: "#4CAF50",
    Failed: "#F44336",
  };

  return (
    <div className="qp_container">
      <h2 className="qp_title">Quick Payment (Send Pay Link)</h2>

      
       <div className="qp_group_select ">
  <label>Select Group:</label>

  {loadingGroups ? (
    <p>Loading groups...</p>
  ) : isMobile ? (
    <div className="qp_custom_dropdown">
      <div
        className="qp_dropdown_header"
        onClick={() => setShowGroupList(!showGroupList)}
      >
        {selectedGroup
          ? groups.find((g) => g.group_code === selectedGroup)?.name
          : "Select Group"}
      </div>

      {showGroupList && (
        <div className="qp_dropdown_list">
          {groups.map((g) => (
            <div
              key={g.group_code}
              className="qp_dropdown_item"
              onClick={() => {
                setSelectedGroup(g.group_code);
                setSelectedStudent(null);
                setShowGroupList(false);
              }}
            >
              {g.name}
            </div>
          ))}
        </div>
      )}
    </div>
  ) : (
    <select
      value={selectedGroup}
      onChange={(e) => {
        setSelectedGroup(e.target.value);
        setSelectedStudent(null);
      }}
    >
      <option value="">--Select Group--</option>
      {groups.map((g) => (
        <option key={g.group_code} value={g.group_code}>
          {g.name}
        </option>
      ))}
    </select>
  )}
</div>
      {/* Student select */}
      {loadingStudents ? (
        <p>Loading students...</p>
      ) : (
        students.length > 0 && (
          <div className="qp_student_select">
            <label>Select Student:</label>
            <select
              value={selectedStudent?.id || ""}
              onChange={(e) => {
                const student = students.find((s) => s.id === parseInt(e.target.value));
                setSelectedStudent(student);
              }}
            >
              <option value="">--Select Student--</option>
              {students.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.childname} ({s.parentname})
                </option>
              ))}
            </select>
          </div>
        )
      )}

      {/* Amount */}
      <div className="qp_amount_input">
        <label>Amount:</label>
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Enter amount"
          min="1"
        />
      </div>
      <div  style={{color:"black"}} className="qp_payment_mode">
  <label  className="desktop-payment-select">Payment Mode:</label>
  <select    className="desktop-payment-select" value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)}>
    <option value="Cash">💵Cash</option>
    <option value="Online">📱Online</option>
  </select>
{/* mobile */}
  <div className="qp_payment_mode mobile-only">
  <label>Payment Mode:</label>

  {isMobile ? (
    <div className="qp_custom_dropdown">
      <div
        className="qp_dropdown_header"
        onClick={() => setShowPaymentModeList(!showPaymentModeList)}
      >
        {paymentMode || "Select Payment Mode"}
      </div>

      {showPaymentModeList && (
        <div className="qp_dropdown_list">
          <div
            className="qp_dropdown_item"
            onClick={() => {
              setPaymentMode("Cash");
              setShowPaymentModeList(false);
            }}
          >
           💵 Cash
          </div>

          <div
            className="qp_dropdown_item"
            onClick={() => {
              setPaymentMode("Online");
              setShowPaymentModeList(false);
            }}
          >
          📱  Online
          </div>
        </div>
      )}
    </div>
  ) : (
    <select
      value={paymentMode}
      onChange={(e) => setPaymentMode(e.target.value)}
    >
      <option value="Cash">Cash</option>
      <option value="Online">Online</option>
    </select>
  )}
</div>
</div>

<div   style={{color:"black"}} className="qp_notes">
  <label>Notes:</label>
  <input
    value={notes}
    onChange={(e) => setNotes(e.target.value)}
    placeholder="Optional (UTR / Remarks)"
  />
</div>


      <div className="qp_btn_row">
  <button
    className="qp_manual_btn qp_submit_btn"
    onClick={handleManualPayment}
  >
    Manual Entry
  </button>

  <button
    className="qp_submit_btn"
    onClick={handleSendPayLink}
    disabled={processingPayment}
  >
    {processingPayment ? "Generating..." : "Send Pay Link"}
  </button>
</div>

      {showSuccess && <div className="qp_success">✅ Payment link sent successfully! Waiting for UTR confirmation.</div>}
      {showError && <div className="qp_error">❌ Failed to send payment link. Please try again.</div>}


<div className="qp_mobile_container">

<h3>All Payment Links</h3>

{loadingPayLinks ? (
    <p>Loading...</p>
) : (

<div className="qp_mobile_list">

{payLinks.map((link)=>(
<div className="qp_mobile_card" key={link.id}>

<div className="qp_mobile_top">

<div className="qp_mobile_avatar">

<img
src={`https://ui-avatars.com/api/?background=675CFF&color=fff&name=${encodeURIComponent(link.student_name)}`}
alt=""
/>

</div>

<div className="qp_mobile_info">

<h4>{link.student_name}</h4>

<p>{link.class_name}</p>

<p>{link.phone}</p>

</div>

<div className="qp_mobile_amount">

<h3>₹{link.amount}</h3>

<span
className={`qp_mobile_status ${link.status.toLowerCase()}`}
>
{link.status}
</span>

</div>

</div>

<div className="qp_mobile_bottom">

<div>

<p>
{new Date(link.created_at).toLocaleDateString()}
</p>

<p>
{new Date(link.created_at).toLocaleTimeString()}
</p>

</div>

<button
className="qp_action_btn"
onClick={(e)=>{
e.stopPropagation();
setActiveDropdown(
activeDropdown===link.id
?null
:link.id
);
}}
>

<FiMoreVertical/>

</button>

</div>

{/* reuse your existing popup */}

{activeDropdown===link.id && (

<div className="qp_first_dropdown">

<button
onClick={(e)=>{
    e.stopPropagation();
    setStatusSelectDropdown(
        statusSelectDropdown === link.id
            ? null
            : link.id
    );
}}
>
Change Status →
</button>

<button
onClick={()=>{
handleSendReminder(link,"whatsapp")
}}
>
WhatsApp
</button>

<button
onClick={()=>{
handleSendReminder(link,"sms")
}}
>
SMS
</button>

</div>



)}
{statusSelectDropdown === link.id && (
  <div
    className="qp_status_select_dropdown"
    onClick={(e) => e.stopPropagation()}
  >
    <button
      className="paid-btn"
      onClick={() => openStatusModal(link, "Paid")}
    >
      Paid
    </button>

    <button
      className="pending-btn"
      onClick={() => openStatusModal(link, "Pending")}
    >
      Pending
    </button>

    <button
      className="failed-btn"
      onClick={() => openStatusModal(link, "Failed")}
    >
      Failed
    </button>
  </div>
)}
</div>

))}

</div>

)}
</div>


      {/* PAY LINKS TABLE */}
      <div className="qp_table_container">
        <h3>All Payment Links</h3>
        {loadingPayLinks ? (
          <p>Loading payment links...</p>
        ) : (
          <div className="qp_table_wrapper">
            <table className="qp_table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Student</th>
                  <th>Group</th>
                  <th>Amount (₹)</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Date / Time</th>
                  <th>Payment Mode</th>
<th>Description</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {payLinks.map((link, index) => (
                  <tr key={link.id} style={{ backgroundColor: statusColors[link.status] + "12" }}>
                    <td>{index + 1}</td>
                    <td>{link.student_name}</td>
                    <td>{link.class_name}</td>
                    <td>{link.amount}</td>
                    <td>{link.phone}</td>
                    <td style={{ color: statusColors[link.status], fontWeight: 600 }}>{link.status}</td>
                    <td>{new Date(link.created_at).toLocaleString()}</td>
<td>{link.payment_mode || "-"}</td>
<td>{link.description || "-"}</td>
                    <td className="action-td" style={{ position: "relative" }}>
                      {/* 3-dots action button */}
                      <button
                        className="qp_action_btn"
                        ref={(el) => (actionBtnRefs.current[link.id] = el)}
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveDropdown(activeDropdown === link.id ? null : link.id);
                          setStatusSelectDropdown(null);
                        }}
                        disabled={updatingId === link.id}
                      >
                        <FiMoreVertical />
                      </button>

                      {/* FIRST LEVEL POPUP */}
                      {activeDropdown === link.id && (
                        <div
                          className="qp_first_dropdown pop-anim"
                          ref={(el) => (firstDropdownRefs.current[link.id] = el)}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setStatusSelectDropdown(link.id);
                            }}
                          >
                            Change Status →
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSendReminder(link, "whatsapp");
                            }}
                          >
                            Send WhatsApp
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSendReminder(link, "sms");
                            }}
                          >
                            Send SMS
                          </button>
                        </div>
                      )}

                      {/* SECOND LEVEL POPUP (Status options) */}
                      {statusSelectDropdown === link.id && (
                        <div
                          className="qp_status_select_dropdown slide-anim"
                          ref={(el) => (statusDropdownRefs.current[link.id] = el)}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            className="paid-btn"
                            onClick={() => openStatusModal(link, "Paid")}
                          >
                            Paid
                          </button>
                          <button
                            className="pending-btn"
                            onClick={() => openStatusModal(link, "Pending")}
                          >
                            Pending
                          </button>
                          <button
                            className="failed-btn"
                            onClick={() => openStatusModal(link, "Failed")}
                          >
                            Failed
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal */}
      {modalData && (
        <div className="qp_modal_overlay" onClick={() => { setModalData(null); setConfirmModal(false); }}>
          <div
            className="qp_modal_box neon-modal"
            ref={modalRef}
            onClick={(e) => e.stopPropagation()}
            style={{ borderTop: `6px solid ${statusColors[modalData.status]}` }}
          >
            <h3>Update Status: {modalData.status}</h3>
            <p><b>Student:</b> {modalData.student_name}</p>
            <p><b>Phone:</b> {modalData.phone}</p>
            <p><b>Amount:</b> ₹{modalData.amount}</p>

            <input
              type="text"
              placeholder={modalData.status === "Paid" ? "Enter UTR / Payment Details" : "Enter reason"}
              value={modalInput}
              onChange={(e) => setModalInput(e.target.value)}
            />

            {!confirmModal ? (
              <div className="qp_modal_buttons">
                <button onClick={() => setConfirmModal(true)} className="qp_confirm_btn">Save</button>
                <button onClick={() => { setModalData(null); setConfirmModal(false); }} className="qp_cancel_btn">Cancel</button>
              </div>
            ) : (
              <div className="qp_modal_buttons">
                <button onClick={handleConfirmStatusChange} className="qp_confirm_btn">Confirm</button>
                <button onClick={() => setConfirmModal(false)} className="qp_cancel_btn">Back</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickPayment;
